import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function ProtectedRoute({ children, adminOnly = false }) {
    const navigate = useNavigate();

    useEffect(() => {
        const verifyAuth = async () => {
            try {
                // Use the correct endpoint based on adminOnly
                const endpoint = adminOnly ? 
                    'http://localhost:3001/admin/current-user' : 
                    'http://localhost:3001/current-user';
                
                const response = await axios.get(endpoint, {
                    withCredentials: true
                });
                
                // For admin routes, the checkAdmin middleware already verified the role
                if (adminOnly && !response.data) {
                    throw new Error("Admin access required");
                }
            } catch (error) {
                console.error("Auth verification failed:", error);
                navigate('/', { replace: true });
            }
        };

        verifyAuth();
    }, [navigate, adminOnly]);

    return children;
}

export default ProtectedRoute;